import { memo } from 'react';

export default memo(function SectionCard({ title, children }) {
  return (
    <div className="bg-gradient-glass backdrop-blur-sm rounded-lg border border-white/10 p-6 mb-6">
      <h2 className="text-lg font-semibold text-white mb-5 flex items-center gap-2">
        <span className="w-1 h-5 bg-gradient-to-b from-orange-500 to-red-500 rounded-full" />
        {title}
      </h2>
      {children}
    </div>
  );
});
